
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Toast from 'vux/src/components/toast/index.vue'

export default {
name: "",
props: [""],
data() {
return {
content: "",
apiurl: "",
loading: false
};
},
directives: {
TransferDom
},
components: {
Loading,
Toast
},

computed: {},

beforeMount() {},

mounted() {
this.$http.get("./static/api/api.json").then(response => {
this.apiurl = response.api;
});
},

methods: {
sumbits() {
var _this = this;
if (_this.content === "") {
alert("请输入反馈内容");
}
_this.loading = true;
_this.$http
.post(_this.apiurl + "/web/feedback", {
content: _this.content
})
.then(res => {
if (res.code == 200) {
_this.$vux.toast.text("提交成功", "top");
_this.$router.push({
path: "/personal"
});
} else {
alert(res.msg);
}
_this.loading = false;
});
}
},

watch: {}
};



// WEBPACK FOOTER //
// ./src/components/feedback.vue